import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q2 = ({ history }) => {
  const { t } = useTranslation();
  const Q2Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question2')}
      options={Q2Options}
      nextUrl="q3"
      screenName="q2"
    />
  );
};

export default Q2;
